/* eslint-disable */
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PersonView from '../views/PersonView.vue'
import ManageFriendsView from '../views/ManageFriendsView.vue'
import PostView from '@/views/PostView.vue';

const routes: Array<RouteRecordRaw> = [
    {
    path: '/',
    name: 'home',
    component: HomeView,
    },
    {
        path: '/person',
        name: 'person',
        component: PersonView,
    },
    {
        path: '/post',
        name: 'post',
        component: PostView,
    },
    {
        path: '/profile-edit/friends',
        name: 'manage-friends',
        component: ManageFriendsView,
    }
]

const router = createRouter({
    // history: createWebHistory(process.env.BASE_URL),
    // history: createWebHistory(process.env.BASE_URL || 'https://tablinx.local/people/chat/'),
    history: createWebHistory('/people/'),
    routes
})

export default router
